import {mountJsx} from "mojave/mount";
import {Membership} from "./membership/Membership";

mountJsx("._membership-data-container", Membership);
